import script from "./PendencyService.vue?vue&type=script&setup=true&lang=js"
export * from "./PendencyService.vue?vue&type=script&setup=true&lang=js"

import "./PendencyService.vue?vue&type=style&index=0&id=29cf2fcd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29cf2fcd"]])

export default __exports__